import { createPerUserDb } from "@internal/rxdb-core";
import type { RxCollection, RxJsonSchema } from "rxdb";

export interface PlannerDoc {
  id: string;
  type: string;
  user_id: string;
  data: Record<string, unknown>;
}

const dailyPlannerSchema: RxJsonSchema<PlannerDoc> = {
  version: 1,
  primaryKey: "id",
  type: "object",
  properties: {
    id: { type: "string", maxLength: 64 },
    type: { type: "string", maxLength: 32 },
    user_id: { type: "string", maxLength: 36 },
    data: { type: "object" },
  },
  required: ["id", "type", "user_id", "data"],
  indexes: ["type", ["user_id", "type"]],
};

type AppCollections = Record<string, RxCollection> & {
  daily_planner: RxCollection<PlannerDoc>;
};

const dbApi = createPerUserDb<AppCollections>({
  namePrefix: "daily-planner",
  collections: {
    daily_planner: {
      schema: dailyPlannerSchema,
      migrationStrategies: {
        // v0 → v1: widened id maxLength (36 → 64) for "week:{uuid}". No data change.
        1: (oldDoc) => oldDoc,
      },
    },
  },
});

export const { getDb, getDbForUser } = dbApi;
